import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import LayoutBase from "components/layout/base"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import RoutesPlay from "shared/routes-play"
import SignIn from "components/chalky-layout/sign-in"
import {Text} from "shared/base"
import useCurrentUser from "@kaspernj/api-maker/build/use-current-user"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import {View} from "react-native"

export default memo(shapeComponent(class ComponentsSurveysLayout extends ShapeComponent {
  static propTypes = {
    className: PropTypes.string,
    notFound: PropTypes.bool,
    requireUser: PropTypes.bool
  }

  static defaultProps = {
    requireUser: true
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.surveys.layout"})
    const currentUser = useCurrentUser()

    this.setInstance({currentUser, t})
  }

  render() {
    const {currentUser, t} = this.tt
    const {children, className, headerTitle, notFound, requireUser, ...restProps} = this.props
    const showSignIn = requireUser && !currentUser

    return (
      <LayoutBase
        dataSet={this.cache("layoutBaseDataSet", {class: className, component: "surveys/layout"}, [className])}
        headerTitle={headerTitle}
        layout="survey"
        style={this.layoutBaseStyle ||= {
          paddingTop: 10,
          paddingBottom: 10
        }}
        {...restProps}
      >
        <View
          dataSet={this.surveyContentContainer ||= {class: "survey-content-container"}}
          style={this.surveyContentContainerStyle ||= {
            width: "100%",
            maxWidth: 355,
            padding: 24,
            borderRadius: 10,
            marginRight: "auto",
            marginLeft: "auto",
            backgroundColor: "#f6f4f4"
          }}
        >
          {notFound &&
            <Text>
              {t(".not_found_or_no_access")}
            </Text>
          }
          {!notFound && !showSignIn && headerTitle &&
            <h1>{headerTitle}</h1>
          }
          {showSignIn &&
            <>
              <Text
                style={this.cache("signInTitleStyle", {
                  color: "#2c2c96",
                  fontFamily: "DreamChaser",
                  fontSize: 34,
                  textAlign: "center"
                }, [])}
              >
                {t(".sign_in_required_title")}
              </Text>
              <Text
                style={this.cache("signInDescriptionStyle", {
                  marginBottom: 16,
                  color: "#2c2c96",
                  fontSize: 16,
                  fontWeight: 500,
                  textAlign: "center"
                }, [])}
              >
                {t(".sign_in_required_description")}
              </Text>
              <SignIn />
              <View style={this.cache("enterCodeContainerStyle", {marginTop: 16}, [])}>
                <Link to={RoutesPlay.rootPath()}>
                  <Text
                    style={this.cache("enterCodeLinkStyle", {
                      color: "#2c2c96",
                      fontSize: 16,
                      fontWeight: 700,
                      textAlign: "center",
                      textDecorationLine: "underline"
                    }, [])}
                  >
                    {t(".enter_code_or_scan_qr")}
                  </Text>
                </Link>
              </View>
            </>
          }
          {!showSignIn && children}
        </View>
      </LayoutBase>
    )
  }
}))
